import type { UpdateEnrollmentProgress200CourseInstructorBasicInfo } from './updateEnrollmentProgress200CourseInstructorBasicInfo';
import type { UpdateEnrollmentProgress200CourseInstructorSocial } from './updateEnrollmentProgress200CourseInstructorSocial';

/**
 * 강사 정보
 */
export type UpdateEnrollmentProgress200CourseInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: UpdateEnrollmentProgress200CourseInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: UpdateEnrollmentProgress200CourseInstructorSocial;
};
